import FJActionConstant from "../../constant/FJActionConstant";

const initialState = {
  intro: 'NO_INTRO',
  introList: [],
  introStatus: 'loading',
  userChangedIntro: false,
  videoName: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FJActionConstant.INIT_INTROS:
      return {
        ...state,
        introList: action.introList,
      };
    case FJActionConstant.UPDATE_INTRO:
      return {
        ...state,
        intro: action.intro,
      };
    case FJActionConstant.UPDATE_INTRO_STATUS:
      return {
        ...state,
        introStatus: action.status,
      };
    case FJActionConstant.UPDATE_USER_CHANGED_INTRO:
      return {
        ...state,
        userChangedIntro: true,
      }
    case FJActionConstant.UPDATE_EXPORT_VIDEO_NAME:
      return {
        ...state,
        videoName: action.videoName,
      };
    default:
      return state;
  }
}